import { useInView } from "@/hooks/useInView";
import { Radio, ShieldCheck, FileCheck2 } from "lucide-react";

const points = [
  {
    icon: Radio,
    title: "Branża telekomunikacyjna",
    text: "Realizujemy lokalizacje dla operatorów infrastruktury i sieci komórkowych działających na polskim rynku.",
  },
  {
    icon: FileCheck2,
    title: "Umowy długoterminowe",
    text: "Umowa podstawowa to 10 lat, z możliwością przedłużenia aneksem do 29 lat — zgodnie z polskim prawem cywilnym i wymaganiami UKE.",
  },
  {
    icon: ShieldCheck,
    title: "Polski podmiot",
    text: "Telecom BTS — działamy w Polsce, decyzje podejmujemy w Polsce, podpisujesz umowę z polską spółką.",
  },
];

export default function OperatorLogos() {
  const [ref, inView] = useInView();

  return (
    <section
      className="bg-white border-y border-slate-200 py-14"
      aria-label="W jakiej branży działamy"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div
          ref={ref}
          className={`grid sm:grid-cols-3 gap-8 transition-all duration-700 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          {points.map((p, i) => (
            <PointCard key={p.title} point={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function PointCard({ point, index }) {
  const Icon = point.icon;
  return (
    <div
      className="flex items-start gap-4"
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="w-11 h-11 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
        <Icon className="w-5 h-5 text-emerald-700" aria-hidden="true" />
      </div>
      <div>
        <h3 className="font-bold text-slate-900 text-sm mb-1">{point.title}</h3>
        <p className="text-slate-600 text-xs leading-relaxed">{point.text}</p>
      </div>
    </div>
  );
}
